import Vue from "vue";

// axios
import axios from "axios";

const rawAxiosInstance = axios.create({

});

export default rawAxiosInstance;
